import React from 'react';

import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';

import { ConfirmationContainer, ConfirmationMessage } from '../../css';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const Confirmation = ({ fileName, setConfirmDelete, onDeleteFile }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      LIST: {
        confirmationDialog: { CONFIRM, CANCEL }
      }
    },
    general: { confirmDeleteMessage }
  } = localizedStrings;

  return (
    <ConfirmationContainer>
      <ConfirmationMessage>{`${confirmDeleteMessage} ${fileName}?`}</ConfirmationMessage>
      <Button variant={{ priority: 'high', semantic: 'danger' }} onPress={onDeleteFile}>{CONFIRM}</Button>
      <Button
        variant={{ priority: 'low' }}
        onPress={() => {
          setConfirmDelete(false);
        }}
      >
        {CANCEL}
      </Button>
    </ConfirmationContainer>
  );
};

Confirmation.propTypes = {
  fileName: PropTypes.string.isRequired,
  setConfirmDelete: PropTypes.func.isRequired,
  onDeleteFile: PropTypes.func.isRequired
};

export default Confirmation;
